<template>
    <v-snackbar
        v-model="snackbar.view"
        :color="snackbar.color"
    >
      {{ snackbar.text }}

        <template v-slot:action="{ attrs }">
            <v-btn
                text
                v-bind="attrs"
                @click="close"
            >
                Cerrar
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script>
    export default {
        name: 'notification',

        methods: {
            close () {
                this.$store.dispatch('closeNotification')
            }
        },

        computed: {
            snackbar () {
                return this.$store.getters.snackbar
            }
        }
    }
</script>